import { render, staticRenderFns } from "./ResearchOutputList.vue?vue&type=template&id=46f5ea64&scoped=true&"
import script from "./ResearchOutputList.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputList.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputList.vue?vue&type=style&index=0&id=46f5ea64&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f5ea64",
  null
  
)

export default component.exports